<template>
  <div
    class="checkbox"
    :class="{
      'bg-secondary-700 hover:bg-secondary-800 border-[rgba(0,41,17,0.08)] hover:border-secondary-800':
        checked || indeterminate,
      'border-accent-300 hover:border-neutral-400': !checked && !indeterminate,
      disabled: disabled,
    }"
    @click.stop="toggleChecked"
  >
    <font-awesome-icon
      v-if="checked && !indeterminate"
      :icon="['fas', 'check']"
    />
    <font-awesome-icon v-else-if="indeterminate" :icon="['fas', 'dash']" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  checked: {
    type: Boolean,
    default: false,
  },
  indeterminate: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["checked"]);

const toggleChecked = () => {
  if (props.disabled) return;
  emit("checked", !props.checked);
};
</script>

<style scoped>
.checkbox {
  @apply w-4 h-4 border text-white rounded-sm flex justify-center items-center text-xs cursor-pointer;
}
.disabled {
  @apply bg-accent-200;
}
.disabled:hover {
  @apply cursor-not-allowed bg-accent-200;
}
</style>
